// src/components/app.jsx
import React from 'react';
import './app.css';
import './animations.css';

import { Routes, Route } from 'react-router-dom';
import LandingPage from './landing_page_container';
import FranchisePage from './franchise_page';
// Only keep these if you actually use them below
import { AuthRoute, ProtectedRoute } from '../util/route_util';

export default function App() {
  return (
    <Routes>
      {/* Public route */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/franchise" element={<FranchisePage />} />

      {/*
        Examples if you want to use your v6 guards:

        <Route element={<AuthRoute />}>
          <Route path="/login" element={<Login />} />
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
      */}
    </Routes>
  );
}
